export default "__VITE_ASSET__4ebfa8ed__"